import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import './App.css';
import VoucherPage from "./pages/VoucherPage";
import LoginPage from './pages/LoginPage';
import { Toaster } from 'react-hot-toast';
// import RouteChangeTracker from "./utils/RouteChangeTracker";

function App() {
  return (
    <>
      <Router basename="/">
        {/* <RouteChangeTracker /> */}
        <Routes>
          <Route path="/" element={<VoucherPage />} />
          <Route path="/login" element={<LoginPage />} />
        </Routes>
      </Router>
      <Toaster position="top-right" reverseOrder={false} />
    </>
  )
}

export default App;
